import { type Signal, useComputed } from "@suse-o11y/signal";
import React from "react";

import type { TimeRange } from "../../../../../app/state/view/timeline/TimeRange";

import { TimeRangeSelectorContentButton } from "./TimeRangeSelectorContentButton";
import { TimeRangeSelectorSection, type TimeRangeSelectorSectionProps } from "./TimeRangeSelectorSection";

export interface TimeRangeSelectorContentListProps extends TimeRangeSelectorSectionProps {
	timeRange: Signal<TimeRange>;
	timeRanges: ReadonlyArray<TimeRange>;
}

export const TimeRangeSelectorContentList: React.FC<TimeRangeSelectorContentListProps> = ({
	timeRanges,
	timeRange,
	...props
}) => {
	const timeRangeValue = useComputed(timeRange);

	return (
		<TimeRangeSelectorSection {...props}>
			<div className="space-y-2">
				{timeRanges.map((item) => (
					<TimeRangeSelectorContentButton
						key={item.toString()}
						onClick={() => timeRange.write(item)}
						selected={timeRangeValue.isEqual(item)}
						timeRange={item}
					/>
				))}
			</div>
		</TimeRangeSelectorSection>
	);
};
